export class AuthStateModel {
  public authenticated!: boolean;
  public loggedInUser?: string;
}
